module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e194d01!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 643
// module chunks = 1